
import * as reportsApis from "../apis/reports_api";
import moment from "moment";
import {formatDate} from "../utils/formatters";
//action constants
const TRIPS_REPORT_CHANGE = "tripsReportChange";
const TRIPS_REPORT_SUBMITTING = "tripsReportSubmitting";
const TRIPS_REPORT_SUBMITTED = "tripsReportSubmitted";
const TRIP_REPORT_ON_VALIDATE = "tripReportOnValidate";

const initTripReportsErrors = () => ({
    startDate: "",
    endDate: "",
})

const initState = () => ({
    submitting: false,
    error: "",
    info: "",
    disableDates: {from: new Date()},
    startDate: moment().add(-3, 'months').toDate(),
    endDate: new Date(),
    searchVal: "",
    fieldErrors: initTripReportsErrors(),
});

const mutations = {
    [TRIPS_REPORT_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [TRIPS_REPORT_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, info: "", error: ""});
    },
    [TRIPS_REPORT_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, error: payload.error, info: payload.info});
    },
    [TRIP_REPORT_ON_VALIDATE] (state, payload) {
        Object.assign(state, {fieldErrors: {...payload}});
    },
};

const actions = {
    [TRIPS_REPORT_CHANGE] ({commit}, payload) {
        commit(TRIPS_REPORT_CHANGE, payload);
    },
    [TRIP_REPORT_ON_VALIDATE] ({commit, state}) {
        let errors = {};

        let fieldsToValidate = ["startDate", "endDate"];
        fieldsToValidate.forEach( key => {

            if(!state[key]) {
                errors[key] = "This field is required";
            }

        });

        if(moment(state.startDate).isAfter(moment(state.endDate))) {
            errors["startDate"] = "Start date cannot be after end date";
        }

        commit(TRIP_REPORT_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(TRIPS_REPORT_CHANGE, {name: "error", value: "Some fields invalid"});
        }else {
            commit(TRIPS_REPORT_CHANGE, {name: "error", value: ""});
        }
    },
    downloadTripReport({commit, state, rootState}, callback) {

        if(state.error){
            return;
        }

        commit(TRIPS_REPORT_SUBMITTING);

        reportsApis.downloadReport(rootState.globalStore.user.email, {startDate: formatDate(state.startDate),
                                      endDate: formatDate(state.endDate)})
            .then((results) => {
                commit(TRIPS_REPORT_SUBMITTED, {})
                    if(callback) {
                        callback(results);
                    }
                },
                (resultsPromise) => {
                    resultsPromise.then(results => {
                        let error = !results.error? "Failed downloading trips report.": results.error;
                        commit(TRIPS_REPORT_SUBMITTED, {info: "", "error": error});
                        if(callback) {
                            callback(undefined);
                        }
                    });
                })
    },
    emailTripReport({commit, state, rootState}) {

        if(state.error){
            return;
        }

        commit(TRIPS_REPORT_SUBMITTING);

        reportsApis.emailReport(rootState.globalStore.user.email, {startDate: formatDate(state.startDate),
            endDate: formatDate(state.endDate)})
            .then(() => {
                    commit(TRIPS_REPORT_SUBMITTED, {info: "Report emailed"});
                },
                (resultsPromise) => {
                    resultsPromise.then(results => {
                        let error = !results.error? "Failed downloading trips report.": results.error;
                        commit(TRIPS_REPORT_SUBMITTED, {info: "", "error": error});
                    });
                })
    }
}

const tripsReportStore = {
    state: initState(),
    mutations: mutations,
    actions: actions,
}

export default tripsReportStore
